import { BaseModel } from '../base.model';
import { LocalDateTimeString } from './local-date-time-string.model';
import { format } from 'date-fns';
import { LOCAL_DATE_TIME_DATE_SERIALIZATION_FORMAT } from '../../constants/date.constants';
import { LookupBase } from './lookup-base.model';
import { LookupKeys } from '../crm/lookup.model';

export type PolicyVersionMap = { [version: string]: boolean };

export enum PolicyTypes {
  termsOfService = 'termsOfService',
  privacyPolicy = 'privacyPolicy',
}

export const policiesTypeMap = new Map([
  [PolicyTypes.termsOfService, 'Terms of Services'],
  [PolicyTypes.privacyPolicy, 'Privacy Policy'],
]);

export const POLICY_TYPES_LOOKUP: LookupBase[] = Object.values(PolicyTypes)?.map(value => {
  return { [LookupKeys.value]: value, [LookupKeys.description]: policiesTypeMap.get(value) };
});

export enum PolicyStatus {
  published = 'published',
  archived = 'archived',
}

export const policiesStatusesMap = new Map([
  [PolicyStatus.published, 'Published'],
  [PolicyStatus.archived, 'Archived'],
]);

export const POLICY_STATUSES_LOOKUP: LookupBase[] = Object.values(PolicyStatus).map(value => {
  return { [LookupKeys.value]: value, [LookupKeys.description]: policiesStatusesMap.get(value) };
});

export const SILENT_LOOKUP: LookupBase[] = [
  {
    [LookupKeys.value]: true,
    [LookupKeys.description]: 'All Users',
  },
  {
    [LookupKeys.value]: false,
    [LookupKeys.description]: 'Only New Users',
  },
];

export enum PolicyKeys {
  type = 'type',
  version = 'version',
  subversions = 'subversions',
  effectiveDate = 'effectiveDate',
  silent = 'silent',
  status = 'status',
}

export class Policy extends BaseModel {
  [PolicyKeys.type]: PolicyTypes;
  [PolicyKeys.version]: string;
  [PolicyKeys.subversions]: string[] = []; // dbIds => [englishDbId, spanishDbId, portugueseDbId]
  [PolicyKeys.effectiveDate]: LocalDateTimeString = format(new Date(), LOCAL_DATE_TIME_DATE_SERIALIZATION_FORMAT);
  [PolicyKeys.silent]: boolean = true; // all by default
  [PolicyKeys.status]: PolicyStatus;
}
